import { useQuery } from './useQuery';

import { SEARCH } from '~shared/config';

export function useSearch() {
  return useQuery({ field: SEARCH });
}
